<template>
	<div class="latform-hypertalk-container">
		<div class="container-title-box">
			<div class="title">
				平台超话排名
				<div class="subTitle">
					TRENDING TOPICS LEADERBOARD
				</div>
			</div>
		</div>
		<div class="rankListBox">
			<div class="rankList">
				<div class="rankItem" v-for="(item,index) in community" :key="index">
					<div class="rankNum">
						{{index > 2 ? index + 1 : ''}}
						<img class="rankImg" src="../assets/Home/first.png" v-if="index == 0" />
						<img class="rankImg" src="../assets/Home/second.png" v-if="index == 1" />
						<img class="rankImg" src="../assets/Home/third.png" v-if="index == 2" />
					</div>
					<div class="work">
						<img class="workImg" :src="item.img" />
						<div class="workInfo">
							<div class="workTitle ellipsis-1">
								{{item.title}}
							</div>
							<div class="workDesc ellipsis-2">
								{{item.content}}
							</div>
							<div class="peopleComment">
								<div class="people">
									<img class="peopleIcon" src="../assets/Home/people.png" />
									{{item.user_num}}人
								</div>
								<div class="comment">
									<img class="commentIcon" src="../assets/Home/comment.png" />
									{{item.dt_num}}个
								</div>
							</div>
							<div class="tips">
								<div class="tip" v-for="(row,rowIndex) in item.label" :key="rowIndex">
									#{{row}}
								</div>
							</div>
						</div>
					</div>
					<div class="goTo" @click="naviToSuperTalkDetails(item)">进入超话</div>
					<!-- <router-link class="goTo"
						:to="{ path: '/super-talk-details', query: { id: item.id, quId: item.fenqu[0].id} }">进入超话</router-link> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LatformHypertalk',
		data() {
			return {
				community: []
			}
		},
		mounted() {
			this.getCommunity()
		},
		methods: {
			//平台超话排名
			getCommunity() {
				this.$api.post('/Community/community_pm', {
					tj_status: 1,
					pagesize: 10
				}).then(res => {
					if (res.code == 1) {
						this.community = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//超话详情
			naviToSuperTalkDetails(item) {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: '/super-talk-details',
						query: {
							id: item.id,
							quId: item.fenqu && item.fenqu.length > 0 ? item.fenqu[0].id : ''
						}
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.latform-hypertalk-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.container-title-box {
		margin: .6rem auto 0;
		display: flex;
		text-align: center;
		justify-content: center;

		&::before {
			content: '';
			display: inline-block;
			margin-top: .3rem;
			margin-right: .12rem;
			width: 1.65rem;
			height: 0;
			border-top: .01rem dashed #706614;
			opacity: 0.3;
		}

		&::after {
			content: '';
			display: inline-block;
			margin-top: .3rem;
			margin-left: .12rem;
			width: 1.65rem;
			height: 0;
			border-top: .01rem dashed #706614;
			opacity: 0.3;
		}

		.title {
			font-weight: 700;
			font-size: .4rem;
			color: #7C400E;

			.subTitle {
				font-weight: 400;
				font-size: .14rem;
				color: #7C400E;
			}
		}
	}

	.rankListBox {
		width: 12rem;
		margin-top: .5rem;
		margin-bottom: .8rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		overflow: hidden;

		.rankList {
			display: flex;
			flex-direction: column;
			padding: 0 .32rem;

			.rankItem:last-child {
				border-bottom: none;
			}

			.rankItem {
				height: 2.24rem;
				display: flex;
				align-items: center;
				border-bottom: .01rem solid #EAEAEA;
				position: relative;

				.rankNum {
					width: .68rem;
					display: flex;
					align-items: center;
					justify-content: center;
					font-weight: 400;
					font-size: .24rem;
					color: #6B6C30;

					.rankImg {
						width: .36rem;
						height: .42rem;
					}
				}

				.work {
					margin-left: .16rem;
					display: flex;

					.workImg {
						width: 1.6rem;
						height: 1.6rem;
						border-radius: .08rem;
						object-fit: cover;
					}

					.workInfo {
						width: 5.1rem;
						margin-left: .24rem;
						display: flex;
						flex-direction: column;

						.workTitle {
							font-weight: 600;
							font-size: .24rem;
							color: #000000;
						}

						.workDesc {
							margin-top: .1rem;
							font-weight: 400;
							font-size: .14rem;
							line-height: .2rem;
							color: #333333;
						}

						.peopleComment {
							margin-top: .16rem;
							display: flex;
							align-items: center;

							.people,
							.comment {
								margin-right: .2rem;
								display: flex;
								align-items: center;
								font-weight: 400;
								font-size: .14rem;
								color: #7C400E;
								line-height: .2rem;
							}

							.peopleIcon,
							.commentIcon {
								width: .14rem;
								height: .14rem;
								margin-right: .08rem;
							}
						}

						.tips {
							margin-top: .1rem;
							display: flex;
							align-items: center;

							.tip {
								font-size: .14rem;
								color: #786F22;
								line-height: .2rem;
								margin-right: .166rem;
							}
						}
					}
				}

				.goTo {
					position: absolute;
					top: calc(50% - .2rem);
					right: 0;
					width: 1.52rem;
					height: .4rem;
					box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
					border-radius: 6px;
					border: .01rem solid #E29358;
					font-weight: 400;
					font-size: .14rem;
					color: #E29358;
					text-align: center;
					line-height: .4rem;
					cursor: pointer;

					&:hover {
						text-decoration: none;
					}
				}
			}
		}
	}
</style>